import { useTranslation } from "react-i18next";
import SchoolCardComponent from "src/components/user/school-card-component";
import { schoolMockData } from "src/services/school-mock-data/school-mock-data";

function TopRankedSchoolsContainer() {
  const { i18n, t } = useTranslation();
  const dummyData = schoolMockData;

  // Sort the array of objects based on the school rating value.
  dummyData.sort((a, b) => b.rating - a.rating);

  return (
    <div className="flex flex-col gap-6">
      <p
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
        className="text-zinc-600 font-arBold text-3xl mobile:text-2xl"
      >
        {t("schoolCard.container.title")}
      </p>
      <div
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
        className="grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-6"
      >
        {dummyData.map((item, index) => (
          <SchoolCardComponent
            key={index}
            id={item.id}
            schoolName={
              i18n.language === "ar" ? item.schoolName : item.schoolNameEn
            }
            schoolDescription={
              i18n.language === "ar" ? item.description : item.descriptionEn
            }
            rating={item.rating}
            imageUrl={item.images[0]}
          />
        ))}
      </div>
    </div>
  );
}

export default TopRankedSchoolsContainer;
